import { FetchStatus, Property, PropertyType } from "../../../../../base/types";
import { useEffect, useState } from "react";

import { IAsyncBoundProperties } from "../../../../../base/hooks";
import { IHiddenValueProps } from "./IHiddenValueProps";

export const HiddenValueProperties = [
    { id: Property.InitValue, name: 'Value', type: PropertyType.String },
    { id: Property.Field, name: 'Field', type: PropertyType.String },
]

export const useHiddenValueProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IHiddenValueProps>()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const attributes: IHiddenValueProps = {
            value: bindings.getValue(Property.InitValue) || '',
            field: bindings.getValue(Property.Field) || '',
        };

        setProperties(attributes)
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties }
}
